import React, { useState } from 'react'
import { isNil } from 'lodash'
import { IconUser } from '@tabler/icons-react'

import { AnalyticsCard } from '@/components/cards/AnalyticsCard'
import { BasicModal } from '@/components/layout/modals/BasicModal'

import { AiAnswersVerifiedAnswers } from './AiAnswersVerifiedAnswers'

/**
 * @import import { AiAnswersSources } from '@/views/AiAnswers/AiAnswersSources'
 * @param {object} props
 * @param {object} [props.verifiedAnswers] The org's verified answers; null while loading or after a failed load
 * @param {boolean} props.loading Whether the answers are fetching
 * @param {object} props.playbooks The org's playbook options and their load state
 * @param {boolean} props.canAnswer Offers edit and delete on each answer
 * @param {number} props.organizationId The org the answers belong to
 * @param {Function} props.onChange Called after an answer is edited or deleted
 */
export const AiAnswersSources = ({
  verifiedAnswers,
  loading,
  playbooks,
  canAnswer,
  organizationId,
  onChange,
}) => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <div className="analytics-card-grid small-grid">
        <AnalyticsCard
          description="Answered by your team"
          data={isNil(verifiedAnswers) ? '—' : verifiedAnswers.count.toLocaleString()}
          dateDescription="verified answers"
          icon={<IconUser size={18} />}
          accent="brand"
          loading={loading}
          testId="ai-answers-answered-by-team"
          onClick={() => setOpen(true)}
        />
      </div>
      <BasicModal
        title="Answered by your team"
        show={open}
        onClose={() => setOpen(false)}
        size="xlarge"
        scrolling
      >
        <AiAnswersVerifiedAnswers
          verifiedAnswers={verifiedAnswers}
          loading={loading}
          playbooks={playbooks}
          canAnswer={canAnswer}
          organizationId={organizationId}
          onChange={onChange}
        />
      </BasicModal>
    </>
  )
}
